import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formats: [],
  finalKeys: null,
  emptyColumns: null,
  selectedIndex: 0,
  step: 0,
  data: [],
  file: null,
  hasInvalidData: null,
  show: false
};
const ConfigheaderMapSlice = createSlice({
  name: 'configureHeader',
  initialState,
  reducers: {
    setFormats: (state, action) => {
      state.formats = action.payload;
    },
    setFinalKeys: (state, action) => {
      state.finalKeys = action.payload;
    },
    setEmptyColumns: (state, action) => {
      state.emptyColumns = action.payload;
    },
    setSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setFile: (state, action) => {
      state.file = action.payload;
    },
    setHasInvalidData: (state, action) => {
      state.hasInvalidData = action.payload;
    },
    setShow: (state, action) => {
      state.show = action.payload;
    },
  }
});

export const {
  setFormats,
  setFinalKeys,
  setEmptyColumns,
  setSelectedIndex,
  setStep,
  setData,
  setFile,
  setHasInvalidData,
  setShow
} = ConfigheaderMapSlice.actions;

export default ConfigheaderMapSlice.reducer;
